export default __webpack_public_path__ + "ebae903b181fa1c9635fdde335ccd35f.png";